import { render, staticRenderFns } from "./ServiceLocates.vue?vue&type=template&id=36d52309"
import script from "./ServiceLocates.vue?vue&type=script&lang=js"
export * from "./ServiceLocates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports